import { render, staticRenderFns } from "./CustomNotification.vue?vue&type=template&id=7392976b&scoped=true&lang=pug&"
import script from "./CustomNotification.vue?vue&type=script&lang=js&"
export * from "./CustomNotification.vue?vue&type=script&lang=js&"
import style0 from "./CustomNotification.vue?vue&type=style&index=0&id=7392976b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7392976b",
  null
  
)

export default component.exports